import { get } from 'lodash-es'

export default {
  computed: {
    numericWithSpaces() {
      return {
        condition: 'numericWithSpaces',
        error: this.$t('form.error.numericWithSpaces'),
      }
    },
    requiredError() {
      return {
        condition: 'required',
        error: this.$t('form.error.required'),
      }
    },
    emailError() {
      return {
        condition: 'email',
        error: this.$t('form.error.email'),
      }
    },
    zipError() {
      return {
        condition: 'zipCode',
        error: this.$t('form.error.zip'),
      }
    },
    phoneError() {
      return {
        condition: 'phoneNumber',
        error: this.$t('form.error.phone'),
      }
    },
    websiteError() {
      return {
        condition: 'website',
        error: this.$t('form.error.website'),
      }
    },
    bankClearingNrError() {
      return {
        condition: 'validateBankClearingNr',
        error: this.$t('form.error.bankClearingNumber'),
      }
    },
    ibanError() {
      return {
        condition: 'validateIban',
        error: this.$t('form.error.invalidIban'),
      }
    },
    invalidFormatError() {
      return {
        condition: 'format',
        error: this.$t('form.error.invalidFormat'),
      }
    },
  },
  methods: {
    /**
     * formErrorHelper: function
     *
     * inputName: String
     * errorConditions: [{ condition: String, error: String }]
     *
     * return [String]
     */
    formErrorHelper(inputName, errorConditions, index = -1) {
      const errors = []
      const input =
        index >= 0 ? get(this.$v, `${inputName}.$each.$iter.${index}`) : get(this.$v, inputName)

      if (!get(input, '$dirty', false)) {
        return errors
      }

      errorConditions
        .filter(item => !!item)
        .forEach(({ condition, error }) => {
          const inputCondition = get(input, condition)

          !inputCondition && errors.push(error)
        })

      return errors
    },
    formModelErrorHelper(formName, inputName, errorConditions, index = -1) {
      const errors = []
      const input =
        index >= 0
          ? get(this.$v, `${formName}.${inputName}.$each.$iter.${index}`)
          : get(this.$v, `${formName}.${inputName}`)

      if (!get(input, '$dirty', false)) {
        return errors
      }

      errorConditions.forEach(({ condition, error }) => {
        const inputCondition = get(input, condition)

        !inputCondition && errors.push(error)
      })

      return errors
    },
    minLengthError(length) {
      return {
        condition: 'minLength',
        error: this.$t('form.error.minLength', { length }),
      }
    },
    maxLengthError(length) {
      return {
        condition: 'maxLength',
        error: this.$t('form.error.maxLength', { length }),
      }
    },
    maxFilesError(length) {
      return {
        condition: 'maxLength',
        error: this.$t('form.error.maxFiles', { length }),
      }
    },
  },
}
